export default __webpack_public_path__ + "static/media/add_link_alt.8711a526.svg";